// Icon Components for Precat.io using Font Awesome
// Phase 8: Added Bible for Gospel Prayer
// All icons in brand gold color (#d4af37)
// © 2025 precatio, llc

import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faHandsPraying,
  faLightbulb,
  faCommentDots,
  faCalendarCheck,
  faPersonPraying,
  faBookBible
} from '@fortawesome/free-solid-svg-icons';

const GOLD = '#d4af37';

// Calendar Check Icon - Daily Examen (Phase 7 update)
export const CalendarCheckIcon = ({ size = 48 }) => (
  <FontAwesomeIcon 
    icon={faCalendarCheck} 
    style={{ fontSize: size, color: GOLD }} 
  />
);

// Person Praying Icon - Common Prayers (Phase 7)
export const PersonPrayingIcon = ({ size = 48 }) => (
  <FontAwesomeIcon 
    icon={faPersonPraying} 
    style={{ fontSize: size, color: GOLD }} 
  />
);

// Prayer Hands Icon - kept for backwards compatibility
export const PrayerHandsIcon = ({ size = 48 }) => (
  <FontAwesomeIcon 
    icon={faHandsPraying} 
    style={{ fontSize: size, color: GOLD }} 
  />
);

// Number 9 Icon - Custom Novena
export const NineIcon = ({ size = 48 }) => (
  <div style={{ 
    fontSize: size * 0.8, 
    fontWeight: 'bold', 
    color: GOLD,
    fontFamily: "'League Gothic', 'Arial Black', sans-serif",
    lineHeight: 1
  }}>
    9
  </div>
);

// Speech Bubble Icon - Ask Iggy
export const SpeechBubbleIcon = ({ size = 48 }) => (
  <FontAwesomeIcon 
    icon={faCommentDots} 
    style={{ fontSize: size, color: GOLD }} 
  />
);

// Lightbulb Icon - Discernment
export const LightbulbIcon = ({ size = 48 }) => (
  <FontAwesomeIcon 
    icon={faLightbulb} 
    style={{ fontSize: size, color: GOLD }} 
  />
);

// Bible Icon - Gospel Prayer (Phase 8)
export const BibleIcon = ({ size = 48 }) => (
  <FontAwesomeIcon 
    icon={faBookBible} 
    style={{ fontSize: size, color: GOLD }} 
  />
);

// Export all icons
export default {
  CalendarCheckIcon,
  PersonPrayingIcon,
  PrayerHandsIcon,
  NineIcon,
  SpeechBubbleIcon,
  LightbulbIcon,
  BibleIcon
};
